import { Col, Divider, Row } from 'antd';
import { Icon } from '../../components/icon/icon';
import ROUTER from '../../routers/Routers';
import './CartPage.scss';
import ButtonIconGhostSmall from '../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import DrawerDetailModule from './components/DrawerDetailModule/DrawerDetailModule';
import { useCallback, useEffect, useState } from 'react';
import Tag from '../../components/common/Tag/Tag';
import InputComponent from '../../components/common/InputComponent/InputComponent';
import ButtonPrimaryMedium from '../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../utils/string/cn.utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  applyCoupon,
  fetchCart,
  removeCart,
} from '../../store/actions/room.action';
import { Spin } from 'antd';
import { Form } from 'antd';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { Empty } from 'antd';
import { openMessageError } from '../../components/common/Message/openMessageError';
import { Radio } from 'antd';
import ButtonSecondaryLarge from '../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import formatDateTime from '../../utils/dayjs/formatDateTime.util';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { getValueFromString } from '../../utils/data/getValue.utils';
import { roundTo } from '../../utils/geometry/epsilon';
import ButtonIconGhostLarge from '../../components/common/ButtonIconGhost/ButtonIconGhostLarge';
import ButtonIconOutlineLarge from '../../components/common/ButtonIconOutline/ButtonIconOutlineLarge';
import { parseJson } from '../../utils/string/parseJson';
import { CardDetailProduct } from '../../components/card/CardDetailProduct/CardDetailProduct';
import { convertForeignCurrency } from '../../utils/currency/currency.utils';

const CartPage = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { user } = useSelector(state => state.auth);

  const [moduleId, setModuleId] = useState(null);
  const [formPayment, setFormPayment] = useState(null);
  const [totalCoupon, setTotalCoupon] = useState(0);

  const { cart, coupon, order } = useSelector(state => state.room);

  const renderCartItem = item => {
    return (
      <CardDetailProduct
        title={getValueFromString(item.product_name)}
        icon={item.thumbnail}
        content={
          <>
            <div className="flex flex-col items-start self-stretch gap-[12px]">
              <div className="flex items-start justify-start gap-[8px] flex-col self-stretch">
                <div className="flex lg:flex-row flex-col lg:items-center items-start self-stretch lg:gap-[40px] gap-[6px] text-body-medium lg:justify-between">
                  <span className="truncate  text-black-medium">
                    {t('Product name')}
                  </span>
                  <span className="truncate lg:max-w-[350px] max-w-[200px] font-semibold self-stretch">
                    {getValueFromString(item.item_name)}
                  </span>
                </div>
                {!!item.variant_info && (
                  <div className="flex lg:flex-row flex-col lg:items-center items-start self-stretch lg:gap-[40px] gap-[6px] text-body-medium lg:justify-between">
                    <span className="truncate  text-black-medium">
                      {t('Description')}
                    </span>
                    <span className="line-clamp-2 lg:max-w-[350px] max-w-[200px] font-semibold self-stretch">
                      {item.variant_info?.name}
                    </span>
                  </div>
                )}
                {item.size ? (
                  <div className="flex lg:flex-row flex-col lg:items-center items-start self-stretch lg:gap-[40px] gap-[6px] text-body-medium lg:justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Size')}
                    </span>
                    <div>
                      {(() => {
                        if (typeof item.size === 'string') {
                          return (
                            <span className="font-semibold text-black/80 self-stretch">
                              {item.size}
                            </span>
                          );
                        } else {
                          return (
                            <span className="font-semibold text-black/80 self-stretch">
                              {`${roundTo(item.size.depth, 0)}x${roundTo(
                                item.size.height,
                                0
                              )}x${roundTo(item.size.length, 0)} mm`}
                            </span>
                          );
                        }
                      })()}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <Divider type="horizontal" className="!p-0 m-0" />
              <div className="flex lg:flex-row flex-col lg:items-center items-start self-stretch lg:gap-[40px] gap-[6px] text-body-medium lg:justify-between">
                <span className="truncate text-body-medium text-black/60 ">
                  {t('Shipping method')}
                </span>
                <Tag
                  className={
                    'rounded-[4px] bg-[#E0E0E0] gap-[6px] px-[6px] py-[4px]'
                  }
                  label={
                    <>
                      <span className="flex w-[14px] h-[14px]">
                        <Icon.ICEngineering />
                      </span>
                      <span className="text-label-medium text-black/80 font-semibold">
                        {t("Fitta's Staff Installation")}
                      </span>
                    </>
                  }
                />
              </div>
              {/* {user?.id !== '146b0628368811f1a701639775ceb5d7' && ( */}
              <>
                {item.total_wood_price ||
                item.total_accessory_price ||
                item.total_backsplash_price ||
                item.total_countertop_price ? (
                  <Divider type="horizontal" className="!p-0 m-0" />
                ) : null}

                <div className="flex items-start justify-start gap-[8px] flex-col self-stretch">
                  {item.total_wood_price ? (
                    <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                      <span className="truncate text-body-medium text-black/60 ">
                        {t('Wood price')}
                      </span>
                      <span className="truncate font-semibold text-black/80 self-stretch">
                        {convertForeignCurrency(item.total_wood_price)}
                      </span>
                    </div>
                  ) : (
                    <></>
                  )}

                  {item.total_accessory_price ? (
                    <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                      <span className="truncate text-body-medium text-black/60 ">
                        {t('Accessories')}
                      </span>
                      <span className="truncate font-semibold text-black/80 self-stretch">
                        {convertForeignCurrency(item.total_accessory_price)}
                      </span>
                    </div>
                  ) : (
                    <></>
                  )}
                  {item.total_countertop_price ? (
                    <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                      <span className="truncate text-body-medium text-black/60 ">
                        {t('Countertop')}
                      </span>
                      <span className="truncate font-semibold text-black/80 self-stretch">
                        {convertForeignCurrency(item.total_countertop_price)}
                      </span>
                    </div>
                  ) : (
                    <></>
                  )}

                  {item.total_backsplash_price ? (
                    <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                      <span className="truncate text-body-medium text-black/60 ">
                        {t('Backsplash')}
                      </span>
                      <span className="truncate font-semibold text-black/80 self-stretch">
                        {convertForeignCurrency(item.total_backsplash_price)}
                      </span>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
              {/* )} */}
            </div>
            <Divider type="horizontal" className="!p-0 m-0" />
            <div className="flex lg:items-center items-start self-stretch lg:gap-[40px] gap-[6px] text-body-medium justify-between">
              <span className="truncate text-body-large font-semibold text-black/80 ">
                {t('Total price')}
              </span>
              <div className="flex items-center justify-end lg:gap-16 gap-[4px] lg:flex-row flex-col">
                {item.discount_value && item.discount_type ? (
                  <Tag
                    label={
                      <div className="flex items-center justify-center gap-[4px]">
                        <span className="flex w-[16px] h-[16px]">
                          <Icon.ICPercentDiscount />
                        </span>
                        <span className="text-label-medium">
                          {t('{{x}}% Off', {
                            x:
                              item.discount_type === 'PERCENT_DISCOUNT'
                                ? `${item.discount_value || 0}`
                                : `${convertForeignCurrency(item.discount_value)}`,
                          })}
                        </span>
                      </div>
                    }
                    className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                  />
                ) : null}

                <div className="flex lg:gap-[8px] gap-[4px] lg:justify-center lg:items-center items-end lg:flex-row flex-col">
                  <span className="text-body-small line-through text-black-medium">
                    {(() => {
                      if (
                        Number(item.price_after) !== Number(item.price_original)
                      ) {
                        return convertForeignCurrency(
                          Number(item.price_original)
                        );
                      }
                    })()}
                  </span>
                  <span
                    className={cn(
                      'truncate text-body-large font-semibold self-stretch',
                      Number(item.price_after) !== Number(item.price_original)
                        ? 'text-Accents-Red'
                        : 'text-black'
                    )}
                  >
                    {convertForeignCurrency(
                      (() => {
                        if (Number(item.price_after)) {
                          return Number(item.price_after);
                        } else {
                          return (
                            (item.total_wood_price ?? 0) +
                            (item.total_accessory_price ?? 0) +
                            (item.total_countertop_price ?? 0) +
                            (item.total_backsplash_price ?? 0)
                          );
                        }
                      })()
                    )}
                  </span>
                </div>
              </div>
            </div>
          </>
        }
        actions={
          <>
            {['design'].some(i => item.sale_type?.includes(i)) ? (
              <>
                <ButtonIconOutlineMedium
                  icon={<Icon.ICEdit className={'opacity-60'} />}
                  onClick={() => {
                    try {
                      if (item.is_library) {
                        navigate?.(
                          ROUTER.DESIGN +
                            '/' +
                            item.type_design +
                            `?sale_product=${item.design_id}`
                        );
                      } else {
                        navigate?.(
                          ROUTER.DESIGN +
                            '/' +
                            item.type_design +
                            `?design_id=${item.design_id}`
                        );
                      }
                      onClose?.();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />

                <ButtonIconOutlineMedium
                  icon={<Icon.ICAssignmentList className={'opacity-60'} />}
                  onClick={() => setModuleId(item.id)}
                />
              </>
            ) : (
              <></>
            )}

            <ButtonIconOutlineMedium
              icon={<Icon.ICDelete className={'opacity-60'} />}
              onClick={() => {
                dispatch(removeCart({ cartId: item.id })).then(action => {
                  if (action.payload) {
                    openMessageSuccess({ content: t('Successfully') });
                  }
                });
              }}
            />
          </>
        }
      />
    );
  };

  const createNewOrder = useCallback(
    ({ typePayment }) => {
      navigate(ROUTER.PAYMENT, {
        state: {
          data: {
            items: JSON.stringify(cart.data?.cart_items ?? []),
            type: typePayment,
            paid_step: 0,
            amount_paid: 0,
            amount: cart.data?.total_amount,
            order_type: cart.data?.order_type,
            discount: totalCoupon,
            estimated_delivery_date: cart.data?.estimated_delivery_date,
            shipping_fee: cart.data?.shipping_fee,
            ...(cart?.data ?? {}),
          },
        },
      });
      // BE tự thêm phí vận chuyển
    },
    [cart.data, totalCoupon]
  );

  // const handleCoupon = ({ coupon, item }) => {
  //   let discount = 0;
  //   if (coupon?.apply_for === 'special_texture') {
  //     if (item.is_library !== true && item.has_special_texture === true) {
  //       // Nếu là thư viện có thể đã áp dụng coupon hệ thống có thể bỏ qua
  //       let totalPriceSpeicalDesign = Number(item.price_after);
  //       // if (coupon.discount_type === "percent") {
  //       discount =
  //         totalPriceSpeicalDesign * (Number(coupon.discount_value) / 100);
  //       // }
  //       // else if (coupon.discount_type === "amount") {
  //       //   discount = totalPriceSpeicalDesign - Number(coupon.discount_value);
  //       // }
  //     }
  //   } else if (coupon?.apply_for === 'all') {
  //     let totalPriceAllDesign = Number(item.price_after);
  //     // if (coupon.discount_type === "percent") {
  //     discount = totalPriceAllDesign * (Number(coupon.discount_value) / 100);
  //     // }
  //     // else if (coupon.discount_type === "amount") {
  //     //   discount = Number(coupon.discount_value);
  //     // }
  //   }
  //   // else if(coupon?.apply_for==="option"){
  //   //   const beforeDiscount = item.price_original - item.price_after;
  //   //   const afterDiscount = item.price_original * (Number(coupon.discount_value) / 100);

  //   // }
  //   return discount;
  // };

  // const handleTotalPrice = ({ cartItems }) => {
  //   const total = {
  //     ...totalPrice,
  //     totalWoodPrice: 0,
  //     totalStoneAndGlassPrice: 0,
  //     totalAccessoryPrice: 0,
  //     subtotal: 0,
  //   };
  //   if (cartItems?.length) {
  //     cartItems.forEach(item => {
  //       total.totalWoodPrice += Number(item.total_wood_price ?? 0);
  //       total.totalAccessoryPrice += Number(item.total_accessory_price ?? 0);
  //       total.totalStoneAndGlassPrice +=
  //         Number(item.total_countertop_price ?? 0) +
  //         Number(item.total_backsplash_price ?? 0);
  //       if (Number(item.price_after)) {
  //         total.subtotal += Number(item.price_after);
  //       } else {
  //         total.subtotal +=
  //           Number(item.total_wood_price ?? 0) +
  //           Number(item.total_accessory_price ?? 0) +
  //           Number(item.total_countertop_price ?? 0) +
  //           Number(item.total_backsplash_price ?? 0);
  //       }
  //     });
  //     // total.subtotal =
  //     //   total.totalWoodPrice +
  //     //   total.totalAccessoryPrice +
  //     //   total.totalStoneAndGlassPrice;
  //     total.total = total.subtotal - total.totalCouponPrice;
  //     // if (total.subtotal <= 10000000) {
  //     //   total.total += 500000;
  //     // }
  //   }
  //   setTotalPrice(total);
  //   return total;
  // };

  useEffect(() => {
    if (cart.isNeedReloadData) {
      dispatch(fetchCart({ countryCode: country_code }));
    }
  }, [cart.isNeedReloadData]);

  useEffect(() => {
    if (cart.data?.applied_coupons?.length) {
      const totalCoupon = cart.data.applied_coupons.reduce((prev, curr) => {
        if (curr.result) return prev + curr.value;
        else return prev;
      }, 0);
      setTotalCoupon(totalCoupon);
    } else {
      setTotalCoupon(0);
    }
  }, [cart.data]);

  // useEffect(() => {
  //   const total = handleTotalPrice({ cartItems: cart.data?.cart_items });
  //   total.totalCouponPrice = 0;

  //   const firstCoupon = coupon.data?.[0]; // Hiện tại chỉ áp dụng 1 coupon nên sử dụng firstCoupon
  //   if (firstCoupon && firstCoupon.discount_type === 'percent') {
  //     cart.data?.cart_items?.forEach(item => {
  //       total.totalCouponPrice += handleCoupon({ coupon: firstCoupon, item });
  //     });
  //   } else if (firstCoupon && firstCoupon.discount_type === 'amount') {
  //     total.totalCouponPrice += Number(firstCoupon.discount_value);
  //   }

  //   total.total = total.subtotal - total.totalCouponPrice;
  //   setTotalPrice(total);
  // }, [coupon.data, cart.data?.cart_items]);

  if (formPayment) {
    return (
      <>
        <section className="lg:flex lg:pt-24 lg:pb-16 lg:px-[80px] items-center gap-16 self-stretch lg:bg-transparent lg:bg-fills-white">
          <div className="h-[72px] lg:block hidden"></div>
          <div className="flex lg:flex-row flex-col lg:w-[1280px] items-start lg:gap-[80px]">
            <div className="lg:flex lg:!p-0 md:px-20 px-16 py-12 lg:h-[448px] lg:items-start items-center gap-24 self-stretch grow grid grid-cols-5 lg:bg-transparent bg-fills-white">
              <ButtonIconOutlineLarge
                icon={<Icon.ICArrowBack />}
                onClick={() => setFormPayment(null)}
                className="border-none hover:border-none col-span-1"
              />
              <div className="flex flex-col lg:items-start items-center gap-24 grow col-span-3">
                <span className="!font-bold lg:headline-small lg:block hidden">
                  {t('Choose a payment method')}
                </span>
                <span className="!font-bold text-title-large text-center lg:hidden">
                  {t('Payment method')}
                </span>
                <span className="lg:block hidden text-body-large">
                  "
                  {t(
                    'Please choose a suitable payment method to continue. All your transactions are encrypted and absolutely secure.'
                  )}
                  "
                </span>
              </div>
            </div>

            <div className="flex flex-col items-start justify-start lg:gap-[40px] gap-16 lg:!p-0 md:px-20 p-16">
              <Radio.Group
                value={formPayment}
                className="flex flex-col items-start lg:gap-24 gap-16"
                onChange={value => setFormPayment(value.target.value)}
              >
                <div
                  className={cn(
                    'flex lg:w-[760px] flex-col items-start justify-start rounded-[24px] border-[2px] border-solid border-[#E0E0E0] hover:border-[#006EE5] bg-fills-white cursor-pointer',
                    formPayment === 1 ? 'border-[#006EE5]' : ''
                  )}
                  onClick={() => setFormPayment(1)}
                >
                  <div className="flex lg:flex-row flex-col lg:flex-wrap p-[24px] pb-16 lg:justify-between lg:items-center items-start justify-start self-stretch gap-16">
                    <div className="flex items-center gap-[12px]">
                      <Radio value={1} className={cn('w-24 h-24')} />
                      <span className="text-title-large !font-bold">
                        {t('Pay the full order amount')}
                      </span>
                    </div>
                    <span className="!font-bold text-[#006EE5] text-headline-small ml-48">
                      {convertForeignCurrency(cart?.data?.total_amount)}
                    </span>
                  </div>
                  <div className="flex p-[24px] pt-[16px] flex-col items-start gap-[12px] grow border-t-[1px] border-solid border-[#F4F4F4]">
                    <div className="text-body-medium">
                      {t(
                        'Pay 100% of the order value in a single transaction. Your order will be confirmed and processed immediately after a successful transaction.'
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={cn(
                    'flex lg:w-[760px] flex-col items-start justify-start rounded-[24px] border-[2px] border-solid border-[#E0E0E0] hover:border-[#006EE5] bg-fills-white cursor-pointer',
                    formPayment === 2 ? 'border-[#006EE5]' : ''
                  )}
                  onClick={() => setFormPayment(2)}
                >
                  <div className="flex lg:flex-row flex-col lg:flex-wrap p-[24px] pb-16 lg:justify-between lg:items-center items-start justify-start self-stretch gap-24">
                    <div className="flex items-center gap-[12px]">
                      <Radio value={2} className={cn('w-24 h-24')} />
                      <span className="text-title-large !font-bold">
                        {t('Progress payment')}
                      </span>
                    </div>
                    <span className="!font-bold text-[#006EE5] text-headline-small ml-48">
                      {convertForeignCurrency(
                        cart?.data?.payment_installments?.[0]?.amount
                      )}
                    </span>
                  </div>
                  <div className="flex px-[24px] py-[16px] flex-col items-start gap-[8px] grow border-t-[1px] border-solid border-[#F4F4F4]">
                    <div className="text-body-medium">
                      {t(
                        'Payment is divided into 3 times with the total value. You need to pay 50% now to confirm the order, the remaining will be paid according to the schedule.'
                      )}
                    </div>
                  </div>
                  <div className="grid lg:grid-cols-3 lg:grid-rows-1 grid-rows-3 lg:gap-[8px] gap-[2px] p-[24px] pt-[16px] bordert-[1px] border-solid border-[#F4F4F4] self-stretch">
                    {cart.data?.payment_installments?.map((item, index) => {
                      return (
                        <div className="flex py-12 px-16 lg:flex-col lg:justify-start justify-between items-start gap-[4px] self-stretch rounded-[16px] bg-[#F7F7F7]">
                          <span className="text-body-large font-semibold">
                            {t(`${item.installment_no} payment`)}
                          </span>
                          <div className="flex flex-col items-start gap-[4px] self-stretch">
                            <span className="flex items-start gap-[8px] self-stretch">
                              <span className="text-body-small lg:block hidden">
                                {t('Payment due date')}
                              </span>
                              <span
                                className={cn(
                                  'text-body-small',
                                  item.installment_no === 1
                                    ? 'text-[#006EE5]'
                                    : 'text-black-medium'
                                )}
                              >
                                {t(item.name)}
                              </span>
                            </span>
                            <span className="flex items-start gap-[8px] self-stretch">
                              <span className="text-body-medium lg:block hidden">
                                {t('Amount due')}
                              </span>
                              <span className="text-body-medium font-semibold">
                                {convertForeignCurrency(item.amount)}
                              </span>
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Radio.Group>
              <ButtonPrimaryLarge
                title={t('Next')}
                onClick={() => createNewOrder({ typePayment: formPayment })}
                disabled={order.isLoading}
                loading={order.isLoading}
                className="w-full"
              />
            </div>
          </div>
        </section>
      </>
    );
  } else {
    return (
      <>
        <Spin spinning={cart.isLoading} fullscreen={true} size="large" />
        <div className="cart-page relative lg:bg-transparent bg-backgrounds-virtual">
          <section className="lg:flex lg:pt-24 lg:pb-16 lg:px-[80px] py-12 px-16 items-center gap-16 self-stretch lg:bg-transparent bg-fills-white grid grid-cols-3">
            <ButtonIconOutlineMedium
              icon={<Icon.ICArrowBack />}
              onClick={() => navigate(-1)}
              className="lg:hidden"
            />
            <span className="!font-bold lg:headline-small text-title-large lg:text-left text-center">
              {t('Cart')}
            </span>
          </section>
          <section className="flex lg:py-[16px] lg:px-[80px]  items-start gap-24 h-full overflow-auto self-stretch grow">
            <div className="flex lg:flex-row flex-col items-start grow gap-24">
              {cart.data?.cart_items?.length ? (
                <>
                  <div className="flex flex-col items-start gap-16 grow self-stretch lg:!p-0 p-16 pb-[32px]">
                    {cart.data?.cart_items
                      ?.filter(item => item)
                      ?.map(item => {
                        return <>{renderCartItem(item)}</>;
                      })}
                  </div>
                  <Form
                    form={form}
                    className="flex flex-col items-start lg:rounded-[16px] lg:w-[440px] lg:min-w-[440px] lg:!p-0 p-16 w-full bg-fills-white lg:shadow-custom"
                  >
                    <div className="flex lg:p-[24px] lg:py-[24px] py-[16px] items-center gap-[8px] self-stretch border-b-[1px] border-solid border-[#F4F4F4]">
                      <span className="text-title-large !font-bold">
                        {t('Order summary')}
                      </span>
                    </div>

                    <div className="flex py-[16px] lg:px-[24px] items-start gap-[12px] self-stretch border-t-[1px] border-solid border-[#F4F4F4]">
                      <div className="flex content-between items-center self-stretch grow">
                        <span className="text-body-medium font-semibold self-stretch grow text-black/80">
                          {t('Subtotal')}
                        </span>
                        <span className="text-title-medium font-semibold flex gap-[4px] text-black/80">
                          {convertForeignCurrency(
                            (cart?.data?.total_items ?? 0) + totalCoupon
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="flex py-[16px] lg:px-[24px] items-start gap-[12px] self-stretch border-t-[1px] border-solid border-[#F4F4F4]">
                      <div
                        id="addVoucherContainer"
                        className="add-voucher-container h-[32px] justify-start items-start"
                      >
                        <div className="flex gap-[12px] self-stretch justify-start items-start">
                          <div className="flex items-start justify-start gap-[8px] self-stretch grow">
                            <span className="w-36 h-36 flex items-center">
                              <img
                                src="/assets/icons/iconVoucher.svg"
                                alt=" "
                                className="w-full h-full"
                              />
                            </span>
                            <div className="flex flex-col items-start justify-start gap-[4px] self-stretch grow">
                              {!totalCoupon && (
                                <span className="text-label-medium flex items-center self-stretch grow">
                                  {t('Add Discount Code')}
                                </span>
                              )}
                              {!!totalCoupon && (
                                <>
                                  {cart?.data?.applied_coupons?.map(
                                    (item, index) => {
                                      return (
                                        <span
                                          key={index}
                                          className="text-[#258FD2] text-label-large flex items-center self-stretch grow"
                                        >
                                          {item.code}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <ButtonIconGhostSmall
                            id={'buttonExpandVoucher'}
                            icon={<Icon.ICExpandMore />}
                            style={{ border: '1px solid #CFD1D2' }}
                            type="button"
                            onClick={() => {
                              if (
                                cart?.data?.cart_items?.filter(item => item)
                                  ?.length === 0
                              )
                                return;
                              const button = document.querySelector(
                                '#buttonExpandVoucher'
                              );
                              const formVoucher =
                                document.querySelector('#formInputVouncher');
                              if (formVoucher) {
                                if (
                                  formVoucher.classList.contains('absolute')
                                ) {
                                  formVoucher.classList.remove(
                                    'absolute',
                                    '-z-10',
                                    'opacity-0'
                                  );
                                  button.style.transform = 'rotate(180deg)';
                                } else {
                                  formVoucher.classList.add(
                                    'absolute',
                                    '-z-10',
                                    'opacity-0'
                                  );
                                  button.style.transform = 'rotate(0deg)';
                                }
                              }
                            }}
                          />
                        </div>
                        <div
                          id="formInputVouncher"
                          className="flex items-center gap-[8px] self-stretch transition-all duration-300 ease-in-out mt-[12px] absolute -z-10 opacity-0"
                        >
                          <Form.Item
                            name="couponCode"
                            className="self-stretch grow"
                          >
                            <InputComponent
                              placeholder={t('Enter discount code')}
                            />
                          </Form.Item>
                          <Form.Item>
                            <ButtonPrimaryMedium
                              type={'button'}
                              title={t('Apply')}
                              disabled={coupon.data.isLoading}
                              onClick={() => {
                                form.validateFields().then(values => {
                                  dispatch(
                                    fetchCart({
                                      couponCodes: values.couponCode,
                                      countryCode: country_code,
                                    })
                                  );
                                  // dispatch(
                                  //   applyCoupon({
                                  //     couponCode: values.couponCode,
                                  //   })
                                  // ).then(action => {
                                  //   if (action?.payload?.data?.result) {
                                  //     openMessageSuccess({
                                  //       content: t('Successfully!'),
                                  //     });
                                  //   } else {
                                  //     openMessageError({
                                  //       content:
                                  //         action?.payload?.data?.message ||
                                  //         'Error',
                                  //     });
                                  //   }
                                  // });
                                });
                              }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="flex py-[16px] lg:px-[24px] flex-col items-start gap-[12px] self-stretch border-t-[1px] border-solid border-[#F4F4F4]">
                      <div className="flex content-between items-center self-stretch grow">
                        <span className="text-body-medium font-semibold self-stretch grow text-black/60">
                          {t('Total discount')}
                        </span>
                        <span className="text-body-medium font-semibold flex gap-[4px] text-black/80">
                          -{convertForeignCurrency(totalCoupon)}
                        </span>
                      </div>
                      {/* <div className="flex content-between items-center self-stretch grow">
                        <span className="text-body-medium font-semibold self-stretch grow text-black/60">
                          {t('Shipping fee')}
                        </span>
                        <span className="text-body-medium font-semibold flex gap-[4px] text-black/80">
                          {totalPrice.subtotal <= 10000000
                            ? (500000).toLocaleString('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              })
                            : t('Free')}
                        </span>
                      </div> */}
                    </div>
                    <div className="flex flex-col py-[16px] lg:px-[24px] items-start gap-[12px] self-stretch border-t-[1px] border-solid border-[#F4F4F4]">
                      <div className="flex content-between items-center self-stretch grow">
                        <span className="text-body-medium font-semibold self-stretch grow text-black/60">
                          {t('Total price')}
                        </span>
                        <span className="text-title-medium font-semibold flex gap-[4px] text-black/80">
                          {convertForeignCurrency(
                            Number(cart?.data?.total_amount) -
                              Number(cart?.data?.shipping_fee)
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="flex lg:p-[24px] lg:py-[24px] py-[16px] flex-col items-start gap-24 self-stretch grow border-t-[1px] border-solid border-[#F4F4F4]">
                      <ButtonSecondaryLarge
                        title={t('Continue shopping')}
                        onClick={() => {
                          window.location.href = '/';
                        }}
                        className="lg:hidden w-full"
                      />
                      <ButtonPrimaryLarge
                        title={t('Checkout')}
                        disabled={
                          !cart.data?.cart_items?.filter(item => item)?.length
                        }
                        preIcon={<Icon.ICArrowForward />}
                        onClick={() => {
                          setFormPayment(1);
                        }}
                        className="w-full"
                        classNames={{ preIcon: 'lg:block hidden' }}
                      />
                      <div className="flex items-center gap-[8px] self-stretch">
                        <span className="flex w-[34px] h-[24px]">
                          <Icon.ICVisa />
                        </span>
                        <span className="flex w-[34px] h-[24px]">
                          <Icon.ICMasterCard />
                        </span>
                        <span className="flex w-[34px] h-[24px]">
                          <Icon.ICJCB />
                        </span>
                        <span className="flex w-[34px] h-[24px]">
                          <Icon.ICAmex />
                        </span>
                        <span className="flex w-[34px] h-[24px]">
                          <Icon.ICZalo />
                        </span>
                      </div>
                    </div>
                    {country_code === 'vn' && (
                      <div className="flex p-0 lg:py-[16px] lg:px-[24px] flex-col items-start gap-[12px] self-stretch lg:border-[1px] lg:border-solid lg:border-[#F4F4F4]">
                        <div className="flex p-[12px] items-start gap-[12px] self-stretch rounded-[8px] bg-[#F2F8FD]">
                          <div className="flex w-[20px] h-[20px] justify-center items-center gap-[10px] text-[#258FD2]">
                            <Icon.ICDelivery />
                          </div>
                          <div className="flex flex-col items-start gap-[6px] self-stretch">
                            <span className="self-stretch text-body-medium">
                              {t(
                                'Estimated delivery date (Ho Chi Minh City urban area)'
                              )}
                            </span>
                            <span className="text-body-medium font-semibold">
                              {formatDateTime(
                                cart.data?.estimated_delivery_date,
                                'dateFormat.date'
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {totalCoupon ? (
                      <div className="flex p-24 flex-col items-start gap-24 self-stretch grow border-t-[1px] border-solid border-[#F4F4F4]">
                        <div className="flex items-center gap-[8px]">
                          <span className="flex w-[18px] h-[18px] text-[#49AC3E]">
                            <Icon.ICSuccess />
                          </span>
                          <div className="flex items-center gap-[4px]">
                            <span className="text-body-medium text-black/60">
                              {t('You have saved')}
                            </span>

                            <span className="text-body-medium font-semibold">
                              {convertForeignCurrency(totalCoupon)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </Form>
                </>
              ) : (
                <div className="flex self-stretch grow items-center justify-center">
                  <Empty description={false} />
                </div>
              )}
            </div>
          </section>
        </div>
        <DrawerDetailModule
          open={moduleId}
          items={
            cart.data?.cart_items?.find(item => item.id === moduleId)?.data ??
            '[]'
          }
          imageList={(() => {
            const item = cart.data?.cart_items?.find(
              item => item.id === moduleId
            );
            return item ? [item.thumbnail, item.image] : [];
          })()}
          onClose={() => setModuleId(null)}
        />
      </>
    );
  }
};

export default CartPage;

// const CardDetailModule = ({
//   title,
//   content,
//   icon,
//   actions,
//   classNames = { root: '', icon: '', actionsContainer: '' },
// }) => {
//   return (
//     <div
//       className={cn(
//         'flex items-center self-stretch rounded-[16px] bg-fills-white shadow-custom',
//         classNames.root
//       )}
//     >
//       <div className="flex lg:p-[40px] p-16 items-start gap-[8px] self-stretch">
//         <div
//           style={{ backgroundImage: `url(${icon})` }}
//           alt={title}
//           className={cn(
//             'lg:w-[120px] lg:h-[120px] w-[88px] h-[88px] rounded-[2px] bg-[lightgray] bg-center bg-cover bg-no-repeat aspect-square',
//             classNames.icon
//           )}
//         ></div>
//       </div>
//       <div className="flex lg:p-[40px] p-16 ps-0 flex-col items-start gap-[12px] grow self-stretch">
//         <div className="flex content-center items-center gap-[8px] self-stretch">
//           <span className="text-title-medium line-clamp-1 grow truncate">
//             {title}
//           </span>
//           <div
//             className={cn(
//               'flex content-center items-center self-stretch gap-[8px]',
//               classNames.actionsContainer
//             )}
//           >
//             {actions}
//           </div>
//         </div>
//         <div className="flex flex-col items-start gap-[12px] self-stretch grow">
//           {content}
//         </div>
//       </div>
//     </div>
//   );
// };
